<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" fill="none">
    <path
      fill="currentColor"
      d="M18.183 4.016a1.7 1.7 0 0 0-2.775-1.315l-.125.113L4.16 13.938a1.021 1.021 0 0 0-.255.42l-.973 3.207 3.208-.972.117-.043c.076-.033.147-.076.212-.127l.093-.083L17.685 5.217l.114-.125c.247-.302.384-.682.384-1.076Zm1.3 0c0 .696-.242 1.367-.68 1.9l-.199.22L7.481 17.261a2.317 2.317 0 0 1-.96.576l-3.629 1.1H2.89a1.067 1.067 0 0 1-1.329-1.326l.001-.003 1.1-3.627.002-.001.046-.135c.116-.31.298-.592.533-.827L14.364 1.895l.22-.2a3 3 0 0 1 4.9 2.321Z"
    />
  </svg>
</template>
